import { combineReducers } from 'redux';

import authReducer from './auth';
import notificationReducer from './notifications';
import projectReducer from './projects';
import purchaseOrderReducer from './purchaseOrders';

const appReducer = combineReducers({
  auth: authReducer,
  projects: projectReducer,
  notifications: notificationReducer,
  purchaseOrders: purchaseOrderReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'CLEAR_STORE') {
    state = {
      auth: {
        registerMessage: state.auth?.registerMessage,
      },
    };
  }
  return appReducer(state, action);
};

export default rootReducer;
